import { useTranslation } from 'react-i18next';

import * as St from './SavedEstimateList.styles';

const SavedEstimateListSkeleton = () => {
  const { t } = useTranslation();

  return (
    <St.PageWrapper>
      <St.PageGlobalStyles />
      <St.GlobalSkeletonStyles />
      <St.LeftColumn>
        <St.SkeletonItem data-height="large" data-width="large" />
        <St.SkeletonItem data-height="medium" data-width="large" />
        <St.SkeletonItem data-height="medium" data-width="large" />

        <St.Title>{t('ESTIMATE_LIST.TITLE')}</St.Title>

        <St.Row>
          <St.RowTitle>{t('ESTIMATE_LIST.ESTIMATE_NUMBER')}:</St.RowTitle>
          <St.SkeletonItem data-height="large" data-width="small" />
          <St.SkeletonItem data-height="large" data-width="medium" />
        </St.Row>

        <St.Row>
          <St.RowTitle>{t('ESTIMATE_LIST.CUSTOMER_NAME')}:</St.RowTitle>
          <St.SkeletonItem data-height="medium" data-width="small" />
        </St.Row>

        <St.Row>
          <St.RowTitle>{t('ESTIMATE_LIST.EMAIL')}:</St.RowTitle>
          <St.SkeletonItem data-height="medium" data-width="medium" />
        </St.Row>

        <St.Row>
          <St.RowTitle>{t('ESTIMATE_LIST.ADDRESS')}:</St.RowTitle>
          <St.SkeletonItem data-height="medium" data-width="large" />
        </St.Row>
      </St.LeftColumn>

      <St.SkeletonImage />
    </St.PageWrapper>
  );
};

export default SavedEstimateListSkeleton;
